import { render, staticRenderFns } from "./MonthChart.vue?vue&type=template&id=2b9cd924&scoped=true"
import script from "./MonthChart.vue?vue&type=script&lang=js"
export * from "./MonthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9cd924",
  null
  
)

export default component.exports